import { NavLink, ScrollArea } from '@inexture/core';
import { NavLink as RNavLink } from 'react-router';
import { sidebarData, SidebarItem } from './admin.sidebar.tsx';
import './admin.sidebar.css';

const renderLinks = (items: SidebarItem[]) => {
  return items.map(item => (
    <NavLink
      key={item.label}
      label={item.label}
      fw="bold"
      leftSection={item.icon}
      component={RNavLink}
      to={item.href ?? '#'}
      childrenOffset={16}
      defaultOpened={!!item.children}
    >
      {item.children && renderLinks(item.children)}
    </NavLink>
  ));
};
const AdminSidebar = () => {
  return <ScrollArea>{renderLinks(sidebarData)}</ScrollArea>;
};

export default AdminSidebar;
